/**
 * Fetch an image and return a downscaled JPEG data URL so html2canvas
 * never loads multi‑megapixel source assets into the PDF pipeline.
 */
export async function toOptimizedDataUrl(src, maxWidth = 1200, quality = 0.85) {
  const res = await fetch(src)
  const blob = await res.blob()
  const bitmap = await createImageBitmap(blob)

  const scale = Math.min(1, maxWidth / bitmap.width)
  const width = Math.round(bitmap.width * scale)
  const height = Math.round(bitmap.height * scale)

  const canvas = document.createElement('canvas')
  canvas.width = width
  canvas.height = height
  const ctx = canvas.getContext('2d')
  // White fill so transparent PNGs don't become black when converted to JPEG
  ctx.fillStyle = '#ffffff'
  ctx.fillRect(0, 0, width, height)
  ctx.drawImage(bitmap, 0, 0, width, height)
  bitmap.close()

  return canvas.toDataURL('image/jpeg', quality)
}

/** Logo is shown ~106px tall; background fills a footer strip. */
export function maxWidthForPdfImage(img) {
  if (img.getAttribute('alt') === 'Neelkanth Shivay Builders') return 400
  return 1200
}

export const PDF_EXPORT_OPTIONS = {
  image: { type: 'jpeg', quality: 0.75 },
  html2canvas: {
    scale: 1.5,
    useCORS: false,
    allowTaint: false,
    logging: false,
    imageTimeout: 15000,
  },
  jsPDF: {
    unit: 'pt',
    format: [595.28, 841.89],
    orientation: 'portrait',
  },
}
